import React from 'react';
export const Faq = React.lazy(() => import('./Faq'));